import { Autocomplete, Skeleton } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import Notification from "../notification/Notification";
import FormControl from "@material-ui/core/FormControl";
import { TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { SERVICES } from "../../../utils/consts";

const CurrenciesAndPaymentSystemByServiceRelationshipsSelect = ({ submitData, setSubmitData }) => {
  const { t } = useTranslation("otherInterface");

  const [paymentSystems, setPaymentSystems] = useState(null);
  const [currency, setCurrency] = useState(null);

  const [checkedPaymentSystems, setCheckedPaymentSystems] = useState(null);
  const [checkedCurrency, setCheckedCurrency] = useState(null);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchCryptoCurrencies = () => {
    axios.get(`/api/service-relationships?service.name=${SERVICES.ALP_PAY}`, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        let currency = [];

        response.data["hydra:member"].forEach(item => {
          currency.push(item.currency);
        });

        currency = currency.reduce((unique, o) => {
          if (!unique.some(obj => obj.asset === o.asset)) {
            unique.push(o);
          }
          return unique;
        }, []);

        setCurrency(currency);
      }
    }).catch(error => {
      setNotification({
        ...notification,
        visible: true,
        type: "error",
        message: error.response.data.message
      });
    });
  };

  const fetchPaymentSystemByCurrency = (data) => {
    axios.get("/api/service-relationships?currency.asset=" + data, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        let paymentSystem = [];

        response.data["hydra:member"].forEach(item => {
          paymentSystem.push(item.paymentSystem);
        });

        paymentSystem = paymentSystem.reduce((unique, o) => {
          if (!unique.some(obj => obj.subName === o.subName)) {
            unique.push(o);
          }
          return unique;
        }, []);

        setPaymentSystems(paymentSystem);
      }
    }).catch(error => {
      setNotification({
        ...notification,
        visible: true,
        type: "error",
        message: error.response.data.message
      });
    });
  };

  const handleChangeCurrencySelect = (data) => {
    setCheckedCurrency(data);
    setSubmitData({ ...submitData, currency: data });
    fetchPaymentSystemByCurrency(data);
  };

  const handleChangePaymentSystemSelect = (data) => {
    setCheckedPaymentSystems(data);
    setSubmitData({ ...submitData, paymentSystem: data });
  };

  useEffect(() => {  //
    setCheckedCurrency(null);
    setCheckedPaymentSystems(null);
    setPaymentSystems(null);
    setCurrency(null);
    fetchCryptoCurrencies();
  }, []);

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />

      {!currency && (<Skeleton
        variant="rect"
        height={46}
      />)}

      {currency && Object.keys(currency).length !== 0 &&
        <>
          <FormControl>
            <Autocomplete
              options={currency.map((currency) => currency.asset) || []}
              value={checkedCurrency || null}
              onChange={(event, checkedCurrency) => handleChangeCurrencySelect(checkedCurrency)}
              renderInput={(params) => (
                <TextField {...params} label={t("serviceReletionships.currency")} />
              )}
              blurOnSelect
              disableClearable
            />
          </FormControl>
        </>
      }
      {paymentSystems && Object.keys(paymentSystems).length !== 0 &&
        <>
          <FormControl>
            <Autocomplete
              options={paymentSystems.map((paymentSystem) => paymentSystem.name) || []}
              value={checkedPaymentSystems || null}
              onChange={(event, checkedPaymentSystem) => handleChangePaymentSystemSelect(checkedPaymentSystem)}
              renderInput={(params) => (
                <TextField {...params} label={t("serviceReletionships.paymentSystem")} />
              )}
              blurOnSelect
              disableClearable
            />
          </FormControl>
        </>
      }
    </>
  );
};

export default CurrenciesAndPaymentSystemByServiceRelationshipsSelect;